import React, { PureComponent } from 'react';
import experiment from 'experiments/signupRemoveTitle';
import reform from 'components/Reform';
import Fieldset from 'components/Fieldset';
import Dropdown from 'components/Dropdown';
import Button from 'components/Button';
import DatePicker from 'components/DatePicker';
import AddressPicker from 'components/AddressPicker';
import FormError from 'components/FormError';
import PhoneField from 'components/PhoneField';
import PhoneNumberVerification from 'components/PhoneNumberVerification';

const shouldRemoveTitleField = experiment.isTreatment;

class _PersonalInfo extends PureComponent {
  componentDidMount() {
    this.props.exposeExperiment(experiment);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.errorMessage !== this.props.errorMessage) {
      this.props.updateWizardErrorMessage(this.props.errorMessage);
    }
  }

  render() {
    const {
      firstName,
      lastName,
      phoneNumber,
      birthday,
      postal,
      query,
      title,
      city,
      country,
      address,
      address2,
      homeAddress,
      formValid,
      errorMessage,
      handleChange,
      handleFocus,
      onSubmit,
      callWithData,
      setAddressIsManual,
      isManualAddress,
      onAddressExpanded,
      onAddressOptionSelected,
      resetAddressErrors,
      canSendVerification,
      verified,
      retryVerification,
      verificationCode
    } = this.props;

    const isPhoneNumberVerified = __ENV__.MRQ_GAMING_AUTHORITY === 'MGA' ? verified : true;
    const canSubmit = formValid && isPhoneNumberVerified;

    return (
      <form
        onSubmit={onSubmit}
        className="viewcontainer stepPersonal signup"
        name="signupPersonalInfo"
      >
        {shouldRemoveTitleField ? (
          <Fieldset
            field={firstName}
            name="firstName"
            inputType="text"
            labelText="First name (as on ID)"
            autoComplete="given-name"
            onChange={handleChange}
            onFocus={handleFocus}
            testId="signup-firstName"
            hideAsterisk
          />
        ) : (
          <div className="fieldset fieldset--fullflex fieldset--title-container">
            <Dropdown
              name="title"
              placeholder="Title"
              className="dropdown--title dropdown--inline"
              tabIndex={-1}
              value={title.value}
              onChange={handleChange}
              testId="signup-title"
            >
              <span key="Miss">Miss</span>
              <span key="Mr">Mr</span>
              <span key="Mrs">Mrs</span>
              <span key="Ms">Ms</span>
            </Dropdown>
            <Fieldset
              field={firstName}
              name="firstName"
              inputType="text"
              labelText="First name (as on ID)"
              autoComplete="given-name"
              onChange={handleChange}
              onFocus={handleFocus}
              inline
              testId="signup-firstName"
              hideAsterisk
            />
          </div>
        )}
        <Fieldset
          field={lastName}
          name="lastName"
          inputType="text"
          labelText="Surname (as on ID)"
          autoComplete="family-name"
          onChange={handleChange}
          onFocus={handleFocus}
          hideAsterisk
        />
        <DatePicker
          name="birthday"
          labelText="Birthday"
          onChange={handleChange}
          initial={birthday.value || undefined}
          errorMessage={birthday.error}
          valid={birthday.valid}
          required
          testId="signup-birthday"
          hideAsterisk
        />
        {__ENV__.MRQ_GAMING_AUTHORITY === 'MGA' ? (
          <PhoneNumberVerification
            verificationCode={verificationCode}
            phoneNumber={phoneNumber}
            canSendVerification={canSendVerification}
            handleChange={handleChange}
            handleFocus={handleFocus}
            verified={verified}
            callWithData={callWithData}
            retryVerification={retryVerification}
            showOptional
          />
        ) : (
          <PhoneField
            field={phoneNumber}
            name="phoneNumber"
            labelText="Mobile number"
            onChange={handleChange}
            onFocus={handleFocus}
            editable={!verified}
            inline
            showOptional
            className="fieldset fieldset--rightflex verification"
          />
        )}
        <AddressPicker
          query={query}
          homeAddress={homeAddress}
          postal={postal}
          country={country}
          city={city}
          address={address}
          address2={address2}
          setAddressIsManual={setAddressIsManual}
          isManualAddress={isManualAddress}
          resetAddressErrors={resetAddressErrors}
          onAddressExpanded={onAddressExpanded}
          onAddressOptionSelected={onAddressOptionSelected}
          onChange={handleChange}
          onFocus={handleFocus}
          testId="signup-address"
          hideAsterisk
        />
        <div className="fieldset fieldset--rightflex">
          <Button
            name="submit"
            disabled={!canSubmit}
            title={canSubmit ? 'Proceed to step 3 of 3' : 'Please complete the form'}
            buttonText="Next step"
            type="submit"
            data-test-id="signup-button-personalInfo"
            className="button--fullWidth"
          />
        </div>
        <FormError errorMessage={errorMessage} />
      </form>
    );
  }
}

export default reform()(_PersonalInfo);
